export default "__VITE_ASSET__oWvtiKHS__"